document.addEventListener("DOMContentLoaded", () => {
  // ------------------------------------------------------------------
  // FORMULAR PRODUCT CONFIGURABIL
  // ------------------------------------------------------------------

  const modalButton = document.querySelector(
    "#produs-configurabil-formular-trigger"
  );
  const modalForm = document.querySelector(".formular-configurabil");
  const closeButton = document.querySelector(
    ".formular-configurabil .close-button"
  );
  const body = document.querySelector("body");

  if (modalButton) {
    modalButton.addEventListener("click", function () {
      modalForm.style.position = "fixed";
      modalForm.style.display = "grid";
      body.style.overflow = "hidden";
    });

    closeButton.addEventListener("click", function () {
      modalForm.style.display = "none";
      body.style.overflow = "auto";
    });

    modalForm.addEventListener("click", function (event) {
      if (event.target === event.currentTarget) {
        modalForm.style.display = "none";
        body.style.overflow = "auto";
      }
    });
  }

  // ------------------------------------------------------------------
  // END OF FORMULAR PRODUCT CONFIGURABIL
  // ------------------------------------------------------------------

  // ------------------------------------------------------------------
  // PRODUCT VARIABLES
  // ------------------------------------------------------------------

  const imageSwatches = document.querySelectorAll(
    ".product-details .swatch_wrapper .swatches-select .image-swatch"
  );
  const textSwatches = document.querySelectorAll(
    ".product-details .swatch_wrapper .swatches-select .text-only"
  );

  const optionImagesValues = Array.from(
    document.querySelectorAll(
      ".product-details .swatch_wrapper #gl_select_0 .basel-tooltip-label"
    )
  );

  const carouselTrackers = Array.from(
    document.querySelectorAll(".carousel_tracker")
  );
  const carouselSlides = Array.from(
    document.querySelectorAll(".carousel_slide")
  );

  const thumbnailsTrackers = Array.from(
    document.querySelectorAll(".thumbnail_tracker")
  );

  const view3DWrapper = document.querySelector(".media_carousel_slider");
  const view3DTrackers = Array.from(
    document.querySelectorAll(".carousel_view3d_tracker")
  );
  const view3DGallery = document.querySelector(".section_3d .model_wrapper");

  const galleryTrackers = Array.from(
    document.querySelectorAll(".gallery_tracker")
  );

  if (optionImagesValues.length > 0) {
    optionImagesValues[0].classList.add("active");
  }
  // if (view3DTrackers.length > 0) {
  //   document.querySelector(".section_3d").style.display = "block";
  //   view3DGallery.innerHTML = view3DTrackers[0].innerHTML;
  //   view3DGallery.style.height = view3DGallery.clientWidth + "px";
  // } else {
  //   document.querySelector(".section_3d").style.display = "none";
  // }
  if (galleryTrackers.length > 0) {
    galleryTrackers[0].classList.add("active");
  }
  // ------------------------------------------------------------------
  // HANDLE SWATCHES FUNCTION
  // ------------------------------------------------------------------

  function handleSwatchClick(swatch) {
    let currentActive;
    if (swatch.classList.contains("image-swatch")) {
      currentActive = document.querySelector(
        ".product-details .swatch_wrapper .swatches-select .image-swatch.active-swatch"
      );
    } else {
      currentActive = document.querySelector(
        ".product-details .swatch_wrapper .swatches-select .text-only.active-swatch"
      );
    }

    if (currentActive) {
      currentActive.classList.remove("active-swatch");
    }

    swatch.classList.add("active-swatch");

    const currentImageActive = document.querySelector(
      ".product-details .swatch_wrapper .swatches-select .image-swatch.active-swatch"
    );
    const currentTextActive = document.querySelector(
      ".product-details .swatch_wrapper .swatches-select .text-only.active-swatch"
    );

    if (currentImageActive != null && currentTextActive != null) {
      const imageValue = currentImageActive.dataset.value;
      const textValue = currentTextActive.dataset.value;

      // Thumbnails
      const matchingThumbnail = thumbnailsTrackers.find(
        (tracker) =>
          tracker.dataset.one === imageValue &&
          tracker.dataset.two === textValue
      );

      thumbnailsTrackers.forEach((tracker) => {
        tracker.classList.remove("active");

        tracker.scrollTo({
          left: 0,
          behavior: "smooth",
        });
      });

      if (matchingThumbnail) {
        const matchingThumbnailSlide =
          matchingThumbnail.querySelector(".thumbnail_slide");
        matchingThumbnail.classList.add("active");
        matchingThumbnailSlide.classList.add("active");
        view3DWrapper.classList.remove("active");
      } else {
        thumbnailsTrackers[0].classList.add("active");
      }

      // Carousel
      const matchingCarousel = carouselTrackers.find(
        (carousel) =>
          carousel.dataset.one === imageValue &&
          carousel.dataset.two === textValue
      );
      carouselTrackers.forEach((carousel) =>
        carousel.classList.remove("active")
      );
      carouselSlides.forEach((slide) => {
        slide.classList.remove("active");
      });
      if (matchingCarousel) {
        const carouselSlides = Array.from(
          matchingCarousel.querySelectorAll(".carousel_slide")
        );
        matchingCarousel.classList.add("active");
        carouselSlides[0].classList.add("active");
        const new_price = matchingCarousel.dataset.new_price;
        const old_price = matchingCarousel.dataset.old_price;
        if (new_price < old_price) {
          document.querySelector(".price del").textContent = old_price;
          document.querySelector(".price span").textContent = new_price;
        } else {
          document.querySelector(".price del").textContent = "";
          document.querySelector(".price span").textContent = new_price;
        }
      } else {
        carouselTrackers[0].classList.add("active");
        carouselSlides[0].classList.add("active");
      }

      // Swatches Value
      const matchingOptionValue = optionImagesValues.find(
        (option) => option.dataset.one === imageValue
      );

      optionImagesValues.forEach((value) => value.classList.remove("active"));

      if (matchingOptionValue) {
        matchingOptionValue.classList.add("active");
      } else {
        optionImagesValues[0].classList.add("active");
      }

      // 3D view
      const matchingView3D = view3DTrackers.find(
        (view) =>
          view.dataset.one === imageValue && view.dataset.two === textValue
      );
      view3DTrackers.forEach((view) => {
        view.classList.remove("active");
      });

      if (matchingView3D) {
        document.querySelector(".section_3d").style.display = "block";
        view3DGallery.innerHTML = matchingView3D.innerHTML;
        view3DGallery.style.height = view3DGallery.clientWidth + "px";
      } else {
        document.querySelector(".section_3d").style.display = "none";
      }

      // Gallery
      const matchingGallery = galleryTrackers.find(
        (gallery) =>
          gallery.dataset.one === imageValue &&
          gallery.dataset.two === textValue
      );

      galleryTrackers.forEach((gallery) => {
        gallery.classList.remove("active");
      });

      if (matchingGallery) {
        document.querySelector(".gallery_section").style.display = "block";
        matchingGallery.classList.add("active");
      } else {
        document.querySelector(".gallery_section").style.display = "none";
      }
    } else if (currentTextActive != null) {
      const textValue = currentTextActive.dataset.value;

      // Thumbnails
      const matchingThumbnail = thumbnailsTrackers.find(
        (tracker) => tracker.dataset.two === textValue
      );
      thumbnailsTrackers.forEach((tracker) =>
        tracker.classList.remove("active")
      );
      if (matchingThumbnail) {
        const matchingThumbnailSlide =
          matchingThumbnail.querySelector(".thumbnail_slide");
        matchingThumbnail.classList.add("active");
        matchingThumbnailSlide.classList.add("active");
        view3DWrapper.classList.remove("active");
      } else {
        thumbnailsTrackers[0].classList.add("active");
      }

      // Carousel
      const matchingCarousel = carouselTrackers.find(
        (carousel) => carousel.dataset.two === textValue
      );
      carouselTrackers.forEach((carousel) =>
        carousel.classList.remove("active")
      );
      carouselSlides.forEach((slide) => {
        slide.classList.remove("active");
      });
      if (matchingCarousel) {
        const carouselSlides = Array.from(
          matchingCarousel.querySelectorAll(".carousel_slide")
        );
        matchingCarousel.classList.add("active");
        carouselSlides[0].classList.add("active");
        const new_price = matchingCarousel.dataset.new_price;
        const old_price = matchingCarousel.dataset.old_price;
        if (new_price < old_price) {
          document.querySelector(".price del").textContent = old_price;
          document.querySelector(".price span").textContent = new_price;
        } else {
          document.querySelector(".price del").textContent = "";
          document.querySelector(".price span").textContent = new_price;
        }
      } else {
        carouselTrackers[0].classList.add("active");
        carouselSlides[0].classList.add("active");
      }

      // Swatches Value
      const matchingOptionValue = optionImagesValues.find(
        (option) => option.dataset.one === imageValue
      );

      optionImagesValues.forEach((value) => value.classList.remove("active"));

      if (matchingOptionValue) {
        matchingOptionValue.classList.add("active");
      } else {
        optionImagesValues[0].classList.add("active");
      }
      // Gallery
      const matchingGallery = galleryTrackers.find(
        (gallery) => (gallery.dataset.one === gallery.dataset.two) === textValue
      );

      galleryTrackers.forEach((gallery) => {
        gallery.classList.remove("active");
      });

      if (matchingGallery) {
        matchingGallery.classList.add("active");
      } else {
        galleryTrackers[0].classList.add("active");
      }
    } else {
      const imageValue = currentImageActive.dataset.value;

      // Thumbnails
      const matchingThumbnail = thumbnailsTrackers.find(
        (tracker) => tracker.dataset.one === imageValue
      );
      thumbnailsTrackers.forEach((tracker) =>
        tracker.classList.remove("active")
      );
      if (matchingThumbnail) {
        const matchingThumbnailSlide =
          matchingThumbnail.querySelector(".thumbnail_slide");
        matchingThumbnail.classList.add("active");
        matchingThumbnailSlide.classList.add("active");
        view3DWrapper.classList.remove("active");
      } else {
        thumbnailsTrackers[0].classList.add("active");
      }

      // Carousel
      const matchingCarousel = carouselTrackers.find(
        (carousel) => carousel.dataset.one === imageValue
      );
      carouselTrackers.forEach((carousel) =>
        carousel.classList.remove("active")
      );
      carouselSlides.forEach((slide) => {
        slide.classList.remove("active");
      });
      if (matchingCarousel) {
        const carouselSlides = Array.from(
          matchingCarousel.querySelectorAll(".carousel_slide")
        );
        matchingCarousel.classList.add("active");
        carouselSlides[0].classList.add("active");
        const new_price = matchingCarousel.dataset.new_price;
        const old_price = matchingCarousel.dataset.old_price;
        if (new_price < old_price) {
          document.querySelector(".price del").textContent = old_price;
          document.querySelector(".price span").textContent = new_price;
        } else {
          document.querySelector(".price del").textContent = "";
          document.querySelector(".price span").textContent = new_price;
        }
      } else {
        carouselTrackers[0].classList.add("active");
        carouselSlides[0].classList.add("active");
      }

      // Swatches Value
      const matchingOptionValue = optionImagesValues.find(
        (option) => option.dataset.one === imageValue
      );

      optionImagesValues.forEach((value) => value.classList.remove("active"));

      if (matchingOptionValue) {
        matchingOptionValue.classList.add("active");
      } else {
        optionImagesValues[0].classList.add("active");
      }

      // Gallery
      const matchingGallery = galleryTrackers.find(
        (gallery) => gallery.dataset.one === imageValue
      );

      galleryTrackers.forEach((gallery) => {
        gallery.classList.remove("active");
      });

      if (matchingGallery) {
        matchingGallery.classList.add("active");
      } else {
        galleryTrackers[0].classList.add("active");
      }
    }
  }

  // ------------------------------------------------------------------
  // END OF HANDLE SWATCHES FUNCTION
  // ------------------------------------------------------------------

  imageSwatches.forEach((imageSwatch) => {
    imageSwatch.addEventListener("click", (e) => {
      handleSwatchClick(imageSwatch);
    });
  });

  textSwatches.forEach((textSwatch) => {
    textSwatch.addEventListener("click", (e) => {
      handleSwatchClick(textSwatch);
    });
  });

  // ------------------------------------------------------------------
  // SOCIAL SHARING FOR MOBILE
  // ------------------------------------------------------------------
  const shareButton = document.getElementById("shareButton");

  // Check if the Web Share API is supported
  if (navigator.share) {
    shareButton.addEventListener("click", () => {
      navigator
        .share({
          title: "Your sharing title",
          text: "Your sharing text",
          url: "https://your-website-url.com",
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing:", error));
    });
  } else {
    console.log("Web Share API not supported");
  }

  // ------------------------------------------------------------------
  // 360 VIEW HANDLE LOGIC
  // ------------------------------------------------------------------

  const handleModelViewer = () => {
    const modelViewer = document.querySelector(".section_3d model-viewer");
    if (modelViewer !== null) {
      modelViewer.style.height = view3DGallery.clientWidth + "px";
      observer.disconnect();
    }
  };
  const observer = new MutationObserver(handleModelViewer);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  // ------------------------------------------------------------------
  // SEE MORE BUTTON
  // ------------------------------------------------------------------
  const collapseSection = document.querySelector(".product-features");
  const collapseHeight = document.querySelector(".product-features .features");
  const seeMoreButton = document.querySelector(".collapse_button_wrapper");
  const characteristicsSection = document.querySelector(".product-features");
  if (collapseSection) {
    if (collapseHeight.clientHeight < 400) {
      seeMoreButton.style.display = "none";
      collapseSection.style.height = "auto";
    }
    seeMoreButton.addEventListener("click", () => {
      seeMoreButton.classList.toggle("open");
      characteristicsSection.classList.toggle("open");
    });
  }

  // ------------------------------------------------------------------
  // GALLERY GRID VIEW
  // ------------------------------------------------------------------

  // ------------------------------------------------------------------
  // END OF GALLERY GRID VIEW
  // ------------------------------------------------------------------

  const gallerySection = document.querySelector(".gallery_section");
  const listView = document.querySelector(".grid_icons_wrapper .list_view");
  const gridViewTwo = document.querySelector(
    ".grid_icons_wrapper .grid_view_two"
  );
  const gridViewthree = document.querySelector(
    ".grid_icons_wrapper .grid_view_three"
  );

  if (window.innerWidth < 767) {
    gallerySection.classList.add("grid_view_two");
  } else {
    gallerySection.classList.add("grid_view_three");
  }

  listView.addEventListener("click", () => {
    if (
      gallerySection.classList.contains("grid_view_two") ||
      gallerySection.classList.contains("grid_view_three")
    ) {
      gallerySection.classList.remove("grid_view_two");
      gallerySection.classList.remove("grid_view_three");
    }
    gallerySection.classList.add("list_view");
  });

  gridViewTwo.addEventListener("click", () => {
    if (
      gallerySection.classList.contains("list_view") ||
      gallerySection.classList.contains("grid_view_three")
    ) {
      gallerySection.classList.remove("list_view");
      gallerySection.classList.remove("grid_view_three");
    }
    gallerySection.classList.add("grid_view_two");
  });

  gridViewthree.addEventListener("click", () => {
    if (
      gallerySection.classList.contains("list_view") ||
      gallerySection.classList.contains("grid_view_two")
    ) {
      gallerySection.classList.remove("list_view");
      gallerySection.classList.remove("grid_view_two");
    }
    gallerySection.classList.add("grid_view_three");
  });

  // ------------------------------------------------------------------
  // VIDEO GALLERY
  // ------------------------------------------------------------------
  const videoWrapper = document.querySelector(".video_wrapper");
  const videos = document.querySelectorAll(".video_wrapper .product_video");
  if (videos.length > 0) {
    const videoWidth = videos[0].clientWidth;
    videoWrapper.style.width = videos[0].clientWidth * videos.length + "px";
    document.querySelector(".section_video_gallery").style.display = "block";
  } else {
    document.querySelector(".section_video_gallery").style.display = "none";
  }
});

// ------------------------------------------------------------------
// STICKY CALL TO ACTION LOGIC
// ------------------------------------------------------------------

const sticky = document.querySelector("#sticky-add-to-cart");
const trigger = document.querySelector("#trigger");
const stickyImage = document.querySelector("#sticky-add-to-cart img");
const stickyMinusBtn = document.querySelector("#sticky-add-to-cart .sticky-container .minus");
const stickyPlusBtn = document.querySelector("#sticky-add-to-cart .sticky-container .plus");
const stickySelect = document.querySelector("#sticky-add-to-cart .sticky-container select");

let triggerTop = 0;

window.addEventListener("scroll", () => {
  triggerTop = trigger.getBoundingClientRect().top;
  if (triggerTop <= 0) {
    sticky.classList.add("active");
  } else {
    sticky.classList.remove("active");
  }
});

stickyMinusBtn.addEventListener("click", () => {
  if (stickyQuantity.value > 1) {
    stickyQuantity.value--;
  }
});

stickyPlusBtn.addEventListener("click", () => {
  stickyQuantity.value++;
});
if (stickySelect) {
  stickySelect.addEventListener("change", (event) => {
    const option = event.target.selectedOptions[0];
    const variantId = option.value;
    const variantNewPrice = option.dataset.new_price;
    const variantOldPrice = option.dataset.old_price;
    const variantImage = option.dataset.image;

    hiddenInput.value = variantId;
    newPrice.textContent = variantNewPrice;
    stickyImage.src = variantImage;
    if (variantNewPrice !== variantOldPrice) {
      oldPrice.textContent = variantOldPrice;
      oldPrice.classList.remove("hidden");
    } else {
      oldPrice.classList.add("hidden");
    }
  });
}

// ------------------------------------------------------------------
// END OF STICKY CALL TO ACTION LOGIC
// ------------------------------------------------------------------
